/**
 * @file Isolates the literal `import.meta.env` syntax into its own module so
 *       Jest (which transforms sources to CommonJS, and cannot represent
 *       `import.meta` there) can substitute a mock via moduleNameMapper
 *       instead of parsing this file at all.
 * @copyright Copyright (c) 2026 Woolly Bear Software LLC, all rights reserved.
 */
export const viteEnv = import.meta.env;
